import {item, objectDataType} from './item';

type addItemTypename = "item_add"

type pscommand<T> = {
    "type": T extends addItemTypename ? T : never;
    "data": T extends addItemTypename ? objectDataType : never;
};

export type addItemCommand = pscommand<addItemTypename>;

export class addItem extends item {
    public type: addItemTypename = "item_add";

    constructor(data: THREE.Object3D) {
        super(data);
    }

    public object(): addItemCommand {
        return {
            "type" : this.type,
            "data" : this.objectData()
        }
    }

    public jsonString(): string {
        return JSON.stringify(this.object());
    }
}
